import styled from "styled-components";

export const BackButtonContainer = styled.div`
  left: 0;
  position: absolute;
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    position: static;
  }
`;
